var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "elzMGLWUXv01",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 257 256",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.197545 0 0 1.197545-23.613145-19.029539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.433,85.2403c-2.81-2.76-6.65-4.46-10.9-4.46-8.59,0-15.55,6.96-15.55,15.55c0,8.5897,6.96,15.5497,15.55,15.5497s15.55-6.96,15.55-15.5497c0-1.75-.29-3.44-.83-5.01",
    fill: "#83ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.713,91.3799c-.37,1.14-.58,2.35-.58,3.61",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.213,84.8404c-1.64-.89-3.52-1.4-5.52-1.4-4.13,0-7.75,2.17-9.8,5.42",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5734,220.42c25.8906,0,46.8796-20.989,46.8796-46.88s-20.989-46.88-46.8796-46.88c-25.8912,0-46.88,20.989-46.88,46.88s20.9888,46.88,46.88,46.88Z",
    fill: "#e1e6ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.553,71.4902c9.676,0,17.52-7.844,17.52-17.52s-7.844-17.52-17.52-17.52-17.52,7.844-17.52,17.52s7.844,17.52,17.52,17.52Z",
    fill: "#e1e6ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.633,177.82v3.66c0,2.01-1.63,3.65-3.65,3.65h-10.53c-2.01,0-3.65-1.63-3.65-3.65v-3.66",
    fill: "#cbd5e1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.013,164.79h37.41v.37c0,7.28-5.91,13.19-13.19,13.19h-11.02c-7.28,0-13.19-5.91-13.19-13.19v-.37h-.01Z",
    fill: "#cbd5e1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.763,175.68v3.66c0,2.01-1.63,3.65-3.65,3.65h-10.53c-2.01,0-3.65-1.63-3.65-3.65v-3.66",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "elzMGLWUXv011_to",
    transform: "translate(50.795975,174.67273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elzMGLWUXv011_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elzMGLWUXv011_ts",
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.795974,-174.672729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0034,175.919c5-2.64,9.01-6.81,11.45-11.91l3.23-6.73c.29-.6.76-1.08,1.34-1.39l.22-.12c1.51-.79,3.37-.22,4.16,1.29l12.21,23.11c.79,1.51.22,3.37-1.29,4.16-.57.3-1.23.42-1.87.33l-7.43-1.06c-5.5-.78-11.1.19-16.02,2.79l-.38.2-5.63-10.67h.01Z",
    fill: "#83ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6271,178.269l8.4977-4.487l5.6321,10.664-8.4977,4.488c-2.865,1.513-6.4188.415-7.9319-2.45l-.1541-.291c-1.5131-2.865-.4157-6.419,2.4493-7.932l.0046.008Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1334,173.78c5-2.64,9.01-6.81,11.45-11.91l3.23-6.73c.29-.6.76-1.08,1.34-1.39l.22-.12c1.51-.79,3.37-.22,4.16,1.29l12.21,23.11c.79,1.51.22,3.37-1.29,4.16-.57.3-1.23.42-1.87.33l-7.43-1.06c-5.5-.78-11.1.19-16.02,2.79l-.38.2-5.63-10.67h.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4134,182.55l5.22-2.75",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8934,185.35l2.54-1.35",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8934,167.939l-.98-1.87",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4934,193.84l-3.25,1.72c-1.55.82-3.43.64-4.8-.45l-9.42-7.51l5.8-3.06l11.68,9.3h-.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5734,163.539l-2.65-5.01",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4734,180.4l-5.58-10.57",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9196,39.8445l-2.5739-2.5738c-2.2572-2.2573-5.9169-2.2573-8.1742,0l-2.5738,2.5738c-2.2573,2.2573-2.2573,5.917,0,8.1742l2.5738,2.5739c2.2573,2.2572,5.917,2.2572,8.1742,0l2.5739-2.5739c2.2572-2.2572,2.2572-5.9169,0-8.1742Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.793,216.14c1.79,0,3.24-1.45,3.24-3.24c0-1.789-1.45-3.24-3.24-3.24-1.789,0-3.24,1.451-3.24,3.24c0,1.79,1.451,3.24,3.24,3.24Z",
    fill: "#fff924",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.823,93.0802l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.193,93.0802l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.563,93.0802l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.823,102.44l1.91-1.91",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.193,102.44l1.91-1.91",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.563,102.44l1.91-1.91",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.823,112.35l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.193,112.35l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.563,112.35l1.91-1.92",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3534,99.8799l-5.26-11.21",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2134,84.6402l-1.62002-3.44",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.573,212.53l-12.34-1.02",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.803,211.14l-3.79-.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.813,75.1298c-5.69-6.89-14.3-11.29-23.93-11.29-17.13,0-31.0196,13.89-31.0196,31.02c0,17.1302,13.8896,31.0202,31.0196,31.0202s31.02-13.89,31.02-31.0202c0-4.87-1.12-9.48-3.12-13.58",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.593,83.9102c-2.81-2.76-6.65-4.46-10.9-4.46-8.59,0-15.55,6.96-15.55,15.55c0,8.5898,6.96,15.5498,15.55,15.5498s15.55-6.96,15.55-15.5498c0-1.75-.29-3.44-.83-5.01",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.443,67.1302c-7.74-9.08-19.21-14.88-32.03-15.04-23.5196-.29-42.9996,18.68-43.3096,42.2-.16,12.3498,4.92,23.5198,13.15,31.4298c7.0396,6.76,10.9596,16.13,10.9596,25.89v6.56h37.32v-6.22c0-9.89,3.9-19.43,11.02-26.29c8.07-7.78,13.09-18.7,13.09-30.7998c0-6.42-1.42-12.51-3.95-17.98",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.153,162.65h37.41v.37c0,7.28-5.91,13.19-13.19,13.19h-11.02c-7.28,0-13.19-5.91-13.19-13.19v-.37h-.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M216.433,136.2l26.11-26.1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M202.733,127.95l8.39,8.39",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.053,146.12l18.19-18.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.893,136.49l9.63,9.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.533,150.44l13.98-13.98",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M161.213,137.58c2.116,0,3.83-1.715,3.83-3.83s-1.714-3.83-3.83-3.83c-2.115,0-3.83,1.715-3.83,3.83s1.715,3.83,3.83,3.83Z",
    fill: "#83ca32",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.283,152.59c2.116,0,3.83-1.715,3.83-3.83c0-2.116-1.714-3.83-3.83-3.83-2.115,0-3.83,1.714-3.83,3.83c0,2.115,1.715,3.83,3.83,3.83Z",
    fill: "#83ca32",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.003,129.1c2.116,0,3.83-1.714,3.83-3.83c0-2.115-1.714-3.83-3.83-3.83-2.115,0-3.83,1.715-3.83,3.83c0,2.116,1.715,3.83,3.83,3.83Z",
    fill: "#83ca32",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M245.243,111.22c2.116,0,3.83-1.715,3.83-3.83c0-2.116-1.714-3.83-3.83-3.83-2.115,0-3.83,1.714-3.83,3.83c0,2.115,1.715,3.83,3.83,3.83Z",
    fill: "#83ca32",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M213.853,142.85c2.116,0,3.83-1.714,3.83-3.83c0-2.115-1.714-3.83-3.83-3.83-2.115,0-3.83,1.715-3.83,3.83c0,2.116,1.715,3.83,3.83,3.83Z",
    fill: "#83ca32",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2334,91.9399c-.11-.32-.24-.63-.39-.94-1.28-2.73-3.52-4.67-6.05-5.58c1.43-4.35,1.23-9.37-.95-14.02-4.31-9.18-14.69-13.38-23.2-9.39s-11.91,14.67-7.61,23.84c2.14,4.55,5.77,7.88,9.93,9.59-1.02,2.58-1,5.6501.33,8.4701.14.31.3.61.47.9",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2834,77.3903c.02,1.22.21,2.47.58,3.72-.32-.06-.64-.04-.93.09-.97.45-1.23,1.93-.59,3.29s1.94,2.1,2.91,1.65c.3-.14.52-.38.68-.68c3.31,4.78,8.96,6.9,13.54,4.76c4.58-2.15,6.56-7.86,4.99-13.48.35.08.69.07,1-.08.97-.45,1.23-1.93.59-3.29s-1.94-2.1-2.91-1.65c-.3.14-.52.39-.68.69-.73-1.08-1.57-2.03-2.49-2.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3034,87.8096c0,0,2.57,6.21,8.11,5.07c5.53-1.14,9.36-2.15,11.32,2.55",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4934,91.4697c0,0,3.13,5.95-1.28,9.4803-4.41,3.53-7.64,5.83-5.28,10.34",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0734,99.5697c0,0,4.06.8003,8.07-1.08c4.01-1.88,5.21-5.52,5.21-5.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2434,77.3897c1.13-.53,2-1.4,2.55-2.43s1.2-2.13,1.96-3.08c.94-1.17,1.37-2.69,1.17-4.2c1.03,1.12,2.48,1.76,3.98,1.79c1.22.02,2.43.21,3.62.47s2.36.13,3.5-.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.273,176.21c-.78,1.14-1.4,2.44-1.82,3.87-.23-.21-.49-.36-.79-.4-1-.13-1.97.91-2.15,2.33s.48,2.67,1.49,2.8c.31.04.61-.04.89-.2.21,5.51,3.65,10.08,8.4,10.69c4.76.61,9.25-2.95,10.85-8.24.24.24.52.41.84.45c1,.13,1.97-.91,2.15-2.33s-.48-2.67-1.49-2.8c-.31-.04-.62.04-.9.21",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M178.363,173.56c0,0-2.21,3.28,1.26,7.52l.91,2.2c0,0,3.98-2.61,2.42-7.79-1.46-3.21-4.58-1.93-4.58-1.93h-.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M177.923,173.62c0,0-1.29,2.51-6.25,1.79-4.96-.71-8.88-.33-10.25,3.43c0,0-3.28-3.99.45-8.64s7.29-.03,12.48-1.66s3.58,5.07,3.58,5.07l-.01.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.583,195.33c0,0-1.1,6.27,3.9,8.18s8.58,3.05,7.75,7.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.473,194.279c0,0-.53,6.35-5.85,6.92s-9.07.77-9.48,5.58",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M161.823,201.05c0,0,2.83,2.71,7,3.24c4.16.54,6.97-1.76,6.97-1.76",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.68,145.899l14.62-9.12l1.92-9.01-8.94-2.23-14.61,9.12l8.94,2.23-1.93,9.01Z",
    fill: "#cbd5e1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.01,145.369l14.62-9.13l1.92-9.01-8.94-2.22L50,134.129l8.94,2.23-1.93,9.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.53,141.17L86.535,119",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M182,56L122.5,95.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M186.74,66.1299l9.89-17.13-19.63,1.39c5.71,2.74,9.44,8.41,9.7,14.74l.04,1v0Z",
    fill: "#fff924"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M184.91,64.7305l9.89-17.13-19.63,1.39c5.71,2.74,9.44,8.41,9.7,14.74l.04,1v0Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerDelivery);
export default __webpack_public_path__ + "static/media/power-delivery.e7861cb28b81d8c276b6f5e314c67410.svg";
export { ForwardRef as ReactComponent };